import React from "react";
import { Button, Modal } from "react-bootstrap";
import { getCustomerNumber } from "../../Utils/Utils";

const customerNumber = getCustomerNumber();

export const ExistStoreBuilderModal = (props) => {
  return (
    <>
      <Modal {...props} backdrop="static"  dialogClassName="modal-md modal-box" keyboard={false}>
         <Modal.Header
          closeButton
          className="modal-header border-0"
        >
          <h4>{props.exitstorejsontext && props.exitstorejsontext.title}</h4>        
        </Modal.Header>
        <Modal.Body>
          <p>
            {props.exitstorejsontext && props.exitstorejsontext.info}
          </p>
        </Modal.Body>
        <Modal.Footer>
        <Button variant='white' className="modal-btn" id="exit"
               onClick={() =>window.location.href = `/apps/jcom/router.mvc?cn=${customerNumber}`}
        >
            {props.exitstorejsontext && props.exitstorejsontext.leftBtn}
        </Button>
        <Button  variant='white' className="modal-btn" onClick={props.saveto}>
            {props.exitstorejsontext && props.exitstorejsontext.rightBtn}
        </Button>
        </Modal.Footer>

      </Modal>
    </>
  );
};
